import { Grid, Typography } from '@mui/material';
import React from 'react';
import './CallAnalysisCommonComponent.css';
import { useMediaQuery } from '@mui/material';


const CallAnalysisCommonComponent = (props) => {
    const {format, isLast} = props;

const isMobile = useMediaQuery('(min-width: 0px) and (max-width: 768px)');

  return (
    <Grid container>
      <Grid item xs={12} className={`main-common-container-wrapper ${isLast ? "pb-150" : "pb-0"}`}>
        <Grid container justifyContent={"center"}>
            <Grid item xs={10.5} sm={10.4} md={10.4} lg={9.4} xl={8.7} className="main-common-item">
                <Grid container className="call-analysis-common-container-style" flexDirection={{xs: (format.ca_formatId % 2) == 0 ? "row-reverse" : "row"}} sx={{padding: (format.ca_formatId % 2) === 0 ? {xs: "50px 35px 50px 0px", lg: "70px 70px 70px 0px",} : {xs: "50px 0px 50px 35px", lg: "70px 0px 70px 70px"}}}>               
                    <Grid item className="custom-text-col" xl={5.5}>
                      <Grid container gap={3}>
                        <Grid item xs={12} className="call-analysis-common-item-style">
                          <Typography variant="h3" className="ca_main_font_style" >
                            {format.ca_sub_field}
                          </Typography>
                        </Grid>
                        <Grid item xs={12}>
                          <Grid container gap={2}>
                            {format.ca_details.map((detail, index) => (
                                <p className="ca_sub_font_style" key={index}>{detail}</p>
                            ))}
                          </Grid>
                        </Grid>
                      </Grid>       
                    </Grid>
                    <Grid item className="custom-img-col" data-format-id={format.ca_formatId} xl={6}>
                      <img
                        src={isMobile ? format.ca_img_mb : format.ca_img}
                        alt="call-analysis"
                        className="ca_img_cc"
                      />
                    </Grid>
                </Grid>
            </Grid>
         
        </Grid>
      </Grid>
    </Grid>
  );
};

export default CallAnalysisCommonComponent;
